"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = QuestMinibarWindow;

var _react = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _QuestMinibarWindowModule = _interopRequireDefault(require("./QuestMinibarWindow.module.scss"));

var _WindowControls = _interopRequireDefault(require("../../WindowControls/WindowControls"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function QuestMinibarWindow(_ref) {
  var _ref$entries = _ref.entries,
      entries = _ref$entries === void 0 ? [] : _ref$entries,
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? "" : _ref$className,
      style = _ref.style;
  var renderEntry = (0, _react.useCallback)(function (entry) {
    var target = entry.target,
        counter = entry.counter,
        counterMax = entry.counterMax,
        isBlinking = entry.isBlinking;
    return /*#__PURE__*/_react.default.createElement("div", {
      className: (0, _classnames.default)(_QuestMinibarWindowModule.default.entry, isBlinking && _QuestMinibarWindowModule.default.isBlinking)
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: _QuestMinibarWindowModule.default.target
    }, target), counter !== undefined && /*#__PURE__*/_react.default.createElement("div", {
      className: _QuestMinibarWindowModule.default.counter
    }, counterMax ? /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, counter, " / ", counterMax) : counter));
  }, []);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)(_QuestMinibarWindowModule.default.window, className),
    style: style
  }, /*#__PURE__*/_react.default.createElement(_WindowControls.default, {
    classNameDragHandler: _QuestMinibarWindowModule.default.dragHandler,
    classNameCloseBtn: _QuestMinibarWindowModule.default.closeBtn
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: _QuestMinibarWindowModule.default.entries
  }, entries.map(renderEntry)));
}